import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { navigateWithReload } from '../navReload';
import { performLogout } from '../authLogout';
// import * as Constants from '../Constants';

class Sidebar extends Component {
  state = {
    iconHoveredMenu: null,
  };

  // userTypeRoutes = Constants.USER_TYPE_ROUTES
  userTypeRoutes = (function() {
    try {
      return JSON.parse(localStorage.getItem("routes") || 'null');
    } catch (e) {
      return null;
    }
  })()

  // Preserve flyout across hub navigation when opening from main menu icon click.
  _preserveIconFlyoutOnRoute = null;

  toggleMenuState(menuState) {
    
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  isMainMenuVisible(userType, route) {
    if(this.userTypeRoutes && this.userTypeRoutes[userType]) {
      var isVisible = this.userTypeRoutes[userType].some(r => {return r.startsWith(route)})
      return isVisible;
    }
  }

  isSubMenuVisible(userType, route) {
    if(this.userTypeRoutes && this.userTypeRoutes[userType]) {
      var isVisible = this.userTypeRoutes[userType].some(r => {return r===route})
      return isVisible;
    }
  }

  isIconOnlySidebar() {
    return typeof document !== 'undefined' && document.body.classList.contains('sidebar-icon-only');
  }

  isSubMenuExpanded(menuKey) {
    return this.state[menuKey];
  }

  isAnyDropdownClickedOpen() {
    return Object.keys(this.state).some(
      (key) => key !== 'iconHoveredMenu' && this.state[key]
    );
  }

  isFlyoutOpen(menuKey) {
    if (this.isIconOnlySidebar()) {
      if (this.isAnyDropdownClickedOpen()) {
        return this.state[menuKey];
      }
      return this.state.iconHoveredMenu === menuKey;
    }
    return this.state[menuKey];
  }

  getDropdownNavItemClass(basePath, menuKey) {
    const activeClass = this.isPathActive(basePath) ? 'nav-item active' : 'nav-item';
    return `${activeClass}${this.isFlyoutOpen(menuKey) ? ' hover-open' : ''}`;
  }

  closeIconOnlyFlyout = () => {
    if (!this.isIconOnlySidebar()) {
      return;
    }
    this._preserveIconFlyoutOnRoute = null;
    const resetState = { iconHoveredMenu: null };
    Object.keys(this.state).forEach((key) => {
      if (key !== 'iconHoveredMenu') {
        resetState[key] = false;
      }
    });
    this.setState(resetState);
    document.querySelectorAll('#sidebar .nav-link .menu-title').forEach((el) => {
      el.style.width = '';
      el.style.minWidth = '';
    });
  };

  handleDocumentMouseDown = (event) => {
    if (!this.isIconOnlySidebar()) {
      return;
    }
    if (!this.isAnyDropdownClickedOpen() && !this.state.iconHoveredMenu) {
      return;
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar && sidebar.contains(event.target)) {
      return;
    }
    this.closeIconOnlyFlyout();
  };

  onDropdownMenuClick = (menuState, path) => {
    if (this.isIconOnlySidebar()) {
      const willOpen = !this.state[menuState];
      const newState = { iconHoveredMenu: willOpen ? menuState : null };
      Object.keys(this.state).forEach((key) => {
        if (key !== 'iconHoveredMenu') {
          newState[key] = false;
        }
      });
      if (willOpen) {
        newState[menuState] = true;
        this._preserveIconFlyoutOnRoute = menuState;
      } else {
        this._preserveIconFlyoutOnRoute = null;
      }
      this.setState(newState, () => {
        if (willOpen) {
          const navItem = document.querySelector(`#sidebar .nav-item[data-menu-key="${menuState}"]`);
          if (navItem) {
            this.syncIconFlyoutBounds(navItem);
          }
        }
      });
      navigateWithReload(this.props.history, path);
      return;
    }
    this.toggleMenuState(menuState);
    navigateWithReload(this.props.history, path);
  };

  syncIconFlyoutBounds = (navItem) => {
    if (!navItem || !this.isIconOnlySidebar()) {
      return;
    }
    const subMenu = navItem.querySelector(':scope > .sub-menu');
    if (!subMenu) {
      return;
    }
    const flyoutHeaderHeight = 40;
    const viewportPadding = 8;
    const itemRect = navItem.getBoundingClientRect();
    const flyoutStart = itemRect.top + flyoutHeaderHeight;
    const maxHeight = Math.max(120, window.innerHeight - flyoutStart - viewportPadding);
    subMenu.style.maxHeight = `${maxHeight}px`;

    const menuTitle = navItem.querySelector('.nav-link .menu-title');
    if (menuTitle) {
      menuTitle.style.width = '';
      menuTitle.style.minWidth = '';
      window.requestAnimationFrame(() => {
        const flyoutWidth = subMenu.offsetWidth;
        if (flyoutWidth > 0) {
          menuTitle.style.width = `${flyoutWidth}px`;
          menuTitle.style.minWidth = `${flyoutWidth}px`;
        }
      });
    }
  };

  syncOpenIconFlyouts = () => {
    if (!this.isIconOnlySidebar()) {
      return;
    }
    document.querySelectorAll('#sidebar .nav-item.hover-open').forEach((navItem) => {
      this.syncIconFlyoutBounds(navItem);
    });
  };

  handleWindowResize = () => {
    this.syncOpenIconFlyouts();
  };

  onIconMenuMouseEnter = (menuKey, event) => {
    if (this.isIconOnlySidebar() && !this.isAnyDropdownClickedOpen()) {
      this.setState({ iconHoveredMenu: menuKey }, () => {
        if (event && event.currentTarget) {
          this.syncIconFlyoutBounds(event.currentTarget);
        }
      });
    }
  };

  onIconMenuMouseLeave = (menuKey) => {
    if (this.isIconOnlySidebar() && !this.state[menuKey]) {
      this.setState({ iconHoveredMenu: null });
    }
  };

  renderNavLink(path, label, className = 'nav-link') {
    const isActive = this.isPathActive(path);
    return (
      <a
        className={isActive ? `${className} active` : className}
        href={path}
        onClick={(event) => {
          event.preventDefault();
          if (this.isIconOnlySidebar()) {
            this.closeIconOnlyFlyout();
          }
          navigateWithReload(this.props.history, path);
        }}
      >
        <Trans>{label}</Trans>
      </a>
    );
  }

  renderDropdownSubMenu(menuKey, children) {
    if (this.isIconOnlySidebar()) {
      return (
        <ul className="nav flex-column sub-menu">
          {children}
        </ul>
      );
    }
    return (
      <Collapse in={this.isSubMenuExpanded(menuKey)}>
        <ul className="nav flex-column sub-menu">
          {children}
        </ul>
      </Collapse>
    );
  }

  renderSubNavLink(path, label) {
    const userType = localStorage.getItem('UserType');
    if (!userType || !this.isSubMenuVisible(userType, path)) {
      return null;
    }
    return (
      <li className="nav-item">
        {this.renderNavLink(path, label)}
      </li>
    );
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    const resetState = { iconHoveredMenu: null };
    Object.keys(this.state).forEach(i => {
      resetState[i] = false;
    });

    const dropdownPaths = [
      {path:'/apps', state: 'appsMenuOpen'},
      {path:'/basic-ui', state: 'basicUiMenuOpen'},
      {path:'/advanced-ui', state: 'advancedUiMenuOpen'},
      {path:'/form-elements', state: 'formElementsMenuOpen'},
      {path:'/tables', state: 'tablesMenuOpen'},
      {path:'/maps', state: 'mapsMenuOpen'},
      {path:'/icons', state: 'iconsMenuOpen'},
      {path:'/charts', state: 'chartsMenuOpen'},
      {path:'/user-pages', state: 'userPagesMenuOpen'},
      {path:'/error-pages', state: 'errorPagesMenuOpen'},
      {path:'/general-pages', state: 'generalPagesMenuOpen'},
      {path:'/ecommerce', state: 'ecommercePagesMenuOpen'},
      {path:'/actions', state: 'actionsPagesMenuOpen'},
      {path:'/tools', state: 'toolsPagesMenuOpen'},
      {path:'/crm', state: 'crmPagesMenuOpen'},
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isIconOnlySidebar()) {
        if (this._preserveIconFlyoutOnRoute === obj.state) {
          resetState[obj.state] = true;
          resetState.iconHoveredMenu = obj.state;
        }
      } else if (this.isPathActive(obj.path)) {
        resetState[obj.state] = true;
      }
    });
    if (this.isIconOnlySidebar()) {
      this._preserveIconFlyoutOnRoute = null;
    }
    this.setState(resetState, () => {
      if (this.isIconOnlySidebar()) {
        this.syncOpenIconFlyouts();
      }
    });
  } 

  onLogout = (event) => {
    event.preventDefault();
    performLogout(this.props.history);
  };

  render () {
    // console.log(localStorage.getItem('UserType'));
    // console.log(this.state.username)
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar" 
      // style={{position:"fixed"}}
      >
        <div className="sidebar-nav-scroll">
        <ul className="nav">
          <li className="nav-item nav-category"><Trans>&nbsp;</Trans></li>
          {
          localStorage.getItem('UserType') && this.isMainMenuVisible(localStorage.getItem('UserType'),"/dashboard") ?
          <li className={ this.isPathActive('/dashboard') ? 'nav-item active' : 'nav-item' }>
            <a
              className={this.isPathActive('/dashboard') ? 'nav-link active' : 'nav-link'}
              href="/dashboard"
              onClick={(event) => {
                event.preventDefault();
                if (this.isIconOnlySidebar()) {
                  this.closeIconOnlyFlyout();
                }
                navigateWithReload(this.props.history, '/dashboard');
              }}
            >
              <span className="icon-bg"><i className="mdi mdi-cube menu-icon"></i></span>
              <span className="menu-title"><Trans>Dashboard</Trans></span>
            </a>
          </li>
          :<></>
          }
          
          {
            localStorage.getItem('UserType') && this.isMainMenuVisible(localStorage.getItem('UserType'),"/tables") ?
          <li
            className={this.getDropdownNavItemClass('/tables', 'tablesMenuOpen')}
            data-menu-key="tablesMenuOpen"
            onMouseEnter={(event) => this.onIconMenuMouseEnter('tablesMenuOpen', event)}
            onMouseLeave={() => this.onIconMenuMouseLeave('tablesMenuOpen')}
          >
            <div
              className={this.state.tablesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
              onClick={() => this.onDropdownMenuClick('tablesMenuOpen', '/tables')}
              data-toggle="collapse"
            >
              <span className="icon-bg"><i className="mdi mdi-chart-bar menu-icon"></i></span>
              <span className="menu-title"><Trans>Reports</Trans></span>
              <i className="menu-arrow"></i>
            </div>

            {this.renderDropdownSubMenu('tablesMenuOpen', (
              <>
                {this.renderSubNavLink('/tables/business-partner', 'BP Report')}
                {this.renderSubNavLink('/tables/meter-reader', 'MR Report')}
                {this.renderSubNavLink('/tables/billed-business-partners', 'Billed BPs')}
                {this.renderSubNavLink('/tables/unbilled-business-partners', 'Unbilled BPs')}
                {this.renderSubNavLink('/tables/monthly', 'Indents Summary')}
                {this.renderSubNavLink('/tables/bp-ledger', 'BP Ledger')}
                {this.renderSubNavLink('/tables/current-outstandings', 'Outstandings')}
                {this.renderSubNavLink('/tables/billing-ledger', 'Billing Ledger')}
                {this.renderSubNavLink('/tables/sales-report', 'Sales Report')}
                {this.renderSubNavLink('/tables/sales-summary', 'Sales Summary')}
                {this.renderSubNavLink('/tables/bp-outstandings', 'BP Outstandings')}
                {this.renderSubNavLink('/tables/sales-cycle-wise', 'Sales Cycle wise')}
                {this.renderSubNavLink('/tables/sales-cycle-bp-wise', 'Sales Cycle BP wise')}
                {this.renderSubNavLink('/tables/provisional-billing', 'Provisional')}
                {this.renderSubNavLink('/tables/price-report', 'Gas Price Report')}
                {this.renderSubNavLink('/tables/security-deposits', 'Security Deposits')}
                {this.renderSubNavLink('/tables/transaction-ledger', 'Ledger History')}
                {this.renderSubNavLink('/tables/bp-changes-history', 'BP Changes')}
                {this.renderSubNavLink('/tables/tds-retained-report', 'TDS Retained')}
                {this.renderSubNavLink('/tables/onboard', 'Onboard')}
              </>
            ))}
        </li>
        :
        <></>
        }

        {
        localStorage.getItem('UserType') && this.isMainMenuVisible(localStorage.getItem('UserType'),"/actions") ?
        <li
          className={this.getDropdownNavItemClass('/actions', 'actionsPagesMenuOpen')}
          data-menu-key="actionsPagesMenuOpen"
          onMouseEnter={(event) => this.onIconMenuMouseEnter('actionsPagesMenuOpen', event)}
          onMouseLeave={() => this.onIconMenuMouseLeave('actionsPagesMenuOpen')}
        >
          <div
            className={this.state.actionsPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => this.onDropdownMenuClick('actionsPagesMenuOpen', '/actions')}
            data-toggle="collapse"
          >
            <span className="icon-bg"><i className="mdi mdi-flash menu-icon"></i></span>
            <span className="menu-title"><Trans>Actions</Trans></span>
            <i className="menu-arrow"></i>
          </div> 
          {this.renderDropdownSubMenu('actionsPagesMenuOpen', (
            <>
              {this.renderSubNavLink('/actions/receive-payments', 'Receive Payments')}
              {this.renderSubNavLink('/actions/verify-payments', 'Verify Payments')}
              {this.renderSubNavLink('/actions/tariff-settings', 'Tariff Settings')}
              {this.renderSubNavLink('/actions/indents', 'Indents')}
              {this.renderSubNavLink('/actions/bp-change-status', 'BP Change Status')}
              {this.renderSubNavLink('/actions/bp-change-scheme', 'BP Change Scheme')}
              {this.renderSubNavLink('/actions/bp-change-outstanding', 'BP Change Outstand')}
              {this.renderSubNavLink('/actions/bp-change-meter', 'BP Change Meter')}
              {this.renderSubNavLink('/actions/payment-reversal', 'Payment Reversal')}
              {this.renderSubNavLink('/actions/schemes', 'Schemes')}
              {this.renderSubNavLink('/actions/invoice-regeneration', 'Re-Invoice')}
            </>
          ))}
        </li>
        :<></>
        }

        {
        localStorage.getItem('UserType') && this.isMainMenuVisible(localStorage.getItem('UserType'),"/tools") ?
        <li
          className={this.getDropdownNavItemClass('/tools', 'toolsPagesMenuOpen')}
          data-menu-key="toolsPagesMenuOpen"
          onMouseEnter={(event) => this.onIconMenuMouseEnter('toolsPagesMenuOpen', event)}
          onMouseLeave={() => this.onIconMenuMouseLeave('toolsPagesMenuOpen')}
        >
          <div
            className={this.state.toolsPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => this.onDropdownMenuClick('toolsPagesMenuOpen', '/tools')}
            data-toggle="collapse"
          >
            <span className="icon-bg"><i className="mdi mdi-tools menu-icon"></i></span>
            <span className="menu-title"><Trans>Tools</Trans></span>
            <i className="menu-arrow"></i>
          </div> 
          {this.renderDropdownSubMenu('toolsPagesMenuOpen', (
            <>
              {this.renderSubNavLink('/tools/online-payment-reconciliation', 'Payment Methods')}
              {this.renderSubNavLink('/tools/new-connection', 'New Connection')}
              {this.renderSubNavLink('/tools/onboard-process', 'On board Process')}
              {this.renderSubNavLink('/tools/sms-notifications', 'SMS Notifications')}
              {this.renderSubNavLink('/tools/admin-tools', 'Admin Tools')}
            </>
          ))}

        </li>
        :<></>
        }
        { localStorage.getItem('UserType') && this.isMainMenuVisible(localStorage.getItem('UserType'),"/crm") ?
        <li
          className={this.getDropdownNavItemClass('/crm', 'crmPagesMenuOpen')}
          data-menu-key="crmPagesMenuOpen"
          onMouseEnter={(event) => this.onIconMenuMouseEnter('crmPagesMenuOpen', event)}
          onMouseLeave={() => this.onIconMenuMouseLeave('crmPagesMenuOpen')}
        >
          <div
            className={this.state.crmPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'}
            onClick={() => this.onDropdownMenuClick('crmPagesMenuOpen', '/crm')}
            data-toggle="collapse"
          >
            <span className="icon-bg"><i className="mdi mdi-account-group menu-icon"></i></span>
            <span className="menu-title"><Trans>CRM</Trans></span>
            <i className="menu-arrow"></i>
          </div> 
          {this.renderDropdownSubMenu('crmPagesMenuOpen', (
            <>
              {this.renderSubNavLink('/crm/view-consumer-bills', 'View Customer Bills')}
              {this.renderSubNavLink('/crm/new-connection', 'New Connection')}
              {this.renderSubNavLink('/crm/bp-individual-ledger', 'BP Individual Ledger')}
              {this.renderSubNavLink('/crm/receive-payments', 'Receive Payments')}
              {this.renderSubNavLink('/crm/new-grievance', 'New Grievance')}
              {this.renderSubNavLink('/crm/manage-grievance', 'Manage Grievances')}
              {this.renderSubNavLink('/crm/png-cp', 'PNG CP')}
            </>
          ))}

        </li>
        :<></>
        }
        </ul>
        </div>
        <div className="sidebar-footer">
          <ul className="nav">
            <li className="nav-item">
              <a
                className="nav-link sidebar-logout-link"
                href="#logout"
                onClick={this.onLogout}
              >
                <span className="icon-bg"><i className="mdi mdi-logout menu-icon"></i></span>
                <span className="menu-title"><Trans>Logout</Trans></span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {

    // alert(localStorage.getItem('UserType'));
    // alert(this.state.username)
    // console.log(this.state.username)
    // console.log(this.state['username'])

    if(localStorage.getItem('UserType') == null){
      this.props.history.push("/user-pages/login-1")
    }
    this.onRouteChanged();
    document.addEventListener('mousedown', this.handleDocumentMouseDown);
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
    window.removeEventListener('resize', this.handleWindowResize);
  }

}

export default withRouter(Sidebar);